import React from 'react'
import Header from '../Components/Header'

function Example() {
  return (
    <Header/>
  )
}

export default Example